import { combineReducers } from 'redux';

import {
    REQUEST_PAYPAL_DETAILS,
    SUCCESS_PAYPAL_DETAILS,
    FAILURE_PAYPAL_DETAILS
} from './constants';

const details = (state = null, action) => {
    switch (action.type) {
        case SUCCESS_PAYPAL_DETAILS:
            return action.response.payload;
        case REQUEST_PAYPAL_DETAILS:
        case FAILURE_PAYPAL_DETAILS:
            return null;
        default:
            return state;
    }
};

const fetchingDetails = (state = false, action) => {
    switch (action.type) {
        case REQUEST_PAYPAL_DETAILS:
            return true;
        case FAILURE_PAYPAL_DETAILS:
        case SUCCESS_PAYPAL_DETAILS:
            return false;
        default:
            return state;
    }
};

const errorDetails = (state = '', action) => {
    switch (action.type) {
        case FAILURE_PAYPAL_DETAILS:
            return action.response.message;
        case REQUEST_PAYPAL_DETAILS:
        case SUCCESS_PAYPAL_DETAILS:
            return '';
        default:
            return state;
    }
};

export default combineReducers({
    details,
    fetchingDetails,
    errorDetails
});



// WEBPACK FOOTER //
// ./src/services/paypal/reducer.js